module.exports = __webpack_public_path__ + "img/college7.92fe0573.png";